import { Component, OnInit } from '@angular/core';
import { APIUrl } from '../enums/emums';

@Component({
  selector: 'aditya-rnd',
  templateUrl: './rnd.component.html',
  styleUrls: ['./rnd.component.css']
})
export class RndComponent implements OnInit {
  Domain = '';
  constructor() { }

  ngOnInit() {
    this.Domain = APIUrl.Domain;
  }

}
